// src/components/admin/portfoli/AdminPortfolioEditForm.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; 
import fetchData from '../../../api/fetchData'; 
import { useTranslation } from 'react-i18next';
import { supportedLngs } from '../../../i18n';
import './AdminPortfolioEditForm.css'; 

function AdminPortfolioEditForm({ onSaveSuccess }) {

  const { itemId } = useParams(); 
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isEditMode = !!itemId; 
 
  const [portfolioItem, setPortfolioItem] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [projectUrl, setProjectUrl] = useState('');
  const [githubUrl, setGithubUrl] = useState('');
  const [category, setCategory] = useState('');
  const [isSaving, setIsSaving] = useState(false); 
  const [saveStatus, setSaveStatus] = useState({ message: '', type: '' });

  const [editingLanguage, setEditingLanguage] = useState(i18n.language.split('-')[0] || 'ru');


  const [currentTitle, setCurrentTitle] = useState('');
  const [currentDescription, setCurrentDescription] = useState('');


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [isSaving, setIsSaving] = useState(false); // Для кнопки сохранения, позже

  
 useEffect(() => {
    if (isEditMode) { 
      const loadItemData = async () => {
        setLoading(true);
        setError(null);
        try {
          const response = await fetchData(`/admin/portfolio/admin_get_portfolio_item.php?id=${itemId}`, 'GET', null, { credentials: 'include' });
          if (response && response.status === 'success' && response.item) {
            const fetchedItem = response.item;
            setPortfolioItem(fetchedItem);
            setImageUrl(fetchedItem.image_url || '');
            setProjectUrl(fetchedItem.project_url || '');
            setGithubUrl(fetchedItem.github_url || '');
            setCategory(fetchedItem.category || '');

          } else {
            setError(response?.message || 'Не удалось загрузить данные элемента портфолио.');
            setPortfolioItem(null); 
          }
        } catch (err) {
          setError(err.message);
          setPortfolioItem(null);
        } finally {
          setLoading(false);
        }
      };
      loadItemData();
    } else  {
      setPortfolioItem(null);
      setImageUrl('');
      setProjectUrl('');
      setGithubUrl('');
      setCategory('');
     
      setCurrentTitle('');
      setCurrentDescription('');

      setEditingLanguage(i18n.language.split('-')[0] || 'ru'); 
      setLoading(false); 
      setError(null);
    }
  }, [itemId, isEditMode, ]);


useEffect(() => {
  if (isEditMode) {
    if (portfolioItem && portfolioItem.translations) {
      const langData = portfolioItem.translations[editingLanguage] || { title: '', description: '' };
      setCurrentTitle(langData.title || '');
      setCurrentDescription(langData.description || '');
    } else {
  
      setCurrentTitle('');
      setCurrentDescription('');
    }
  } 
}, [editingLanguage, portfolioItem, isEditMode]);


  const handleLanguageTabClick = (langCode) => {
    setEditingLanguage(langCode);
   
  };

const handleSave = async (e) => {
  e.preventDefault();
  setIsSaving(true);
  setSaveStatus({ message: '', type: '' }); 

  const isEdit = !!itemId;
  const payload = {
    itemId: isEdit ? itemId : null, 
    language_code: editingLanguage, 
    title: currentTitle,
    description: currentDescription,
  
    image_url: imageUrl,
    project_url: projectUrl,
    github_url: githubUrl,
    category: category
  };


  try {
      const response = await fetchData(
        `/admin/portfolio/admin_save_portfolio_item.php`, 
        'POST',
        payload,
        { credentials: 'include' }
      );

        if (response && response.status === 'success') {
      const messageToShow = t(response.messageKey, response.details);
      setSaveStatus({ message: messageToShow, type: 'success' });
      
        if (onSaveSuccess) {
            onSaveSuccess();
        }

      
        if (!isEditMode && response.newItemId) {
          setTimeout(() => {
            navigate(`/admin/portfolio/edit/${response.newItemId}`);
          }, 1500);
        }
        
      } else {
        setSaveStatus({ message: t(response.messageKey || 'admin.portfolio.saveErrorGeneric', { details: response?.message || 'Unknown error' }), type: 'error' });
      }
    } catch (err) {
      setSaveStatus({ message: t('messages.error.generic', { details: err.message }), type: 'error' });
    } finally {
      setIsSaving(false);
      setTimeout(() => setSaveStatus({ message: '', type: '' }), 5000);
    }
  };



 if (loading) return <p>{t('messages.loading')}</p>;
  if (error && isEditMode) return <p>{t('messages.error.generic', { details: error })}</p>; 
  if (isEditMode && !portfolioItem) return <p>{t('admin.portfolio.itemNotFound', 'Элемент портфолио не найден.')}</p>; 

  
if (isEditMode && !portfolioItem) {
 
  return <p>{t('admin.portfolio.itemNotFound', 'Элемент портфолио не найден.')}</p>;
}

const displayTitleInHeader = isEditMode && portfolioItem 
    ? portfolioItem.translations?.[editingLanguage]?.title || portfolioItem.translations?.['ru']?.title || `Item #${itemId}`
    : `New Item`; // Или t('admin.portfolio.newItemTitle')


  return (
 <div className="admin-portfolio-edit-form">
      <h3>
        {isEditMode && portfolioItem
          ? t('admin.portfolio.editTitle', { 
              id: itemId, 
              title: portfolioItem?.translations?.[editingLanguage]?.title || portfolioItem?.translations?.['ru']?.title || `Item #${itemId}` 
            }) 
          : t('admin.portfolio.addTitle', 'Добавление нового проекта портфолио') 
        }
      </h3>

      <div className="language-tabs">
        {supportedLngs.map(langCode => (
          <button
            key={langCode}
            onClick={() => handleLanguageTabClick(langCode)}
            disabled={editingLanguage === langCode}
            className={editingLanguage === langCode ? 'active' : ''}
          >
            {langCode.toUpperCase()}
          </button>
        ))}
        {/* Можно добавить кнопку "Добавить перевод для нового языка", но это позже */}
      </div>
       
      <form onSubmit={handleSave}>
 
        <fieldset> 
          <legend>{t('admin.portfolio.commonDataLegend')}</legend>
          
          <div>
            <label htmlFor="imageUrl">{t('admin.portfolio.imageUrlLabel')}:</label>
            <input type="text" id="imageUrl" value={imageUrl} onChange={e => setImageUrl(e.target.value)} />
          </div>
          <div>
            <label htmlFor="projectUrl">{t('admin.portfolio.projectUrlLabel')}:</label>
            <input type="text" id="projectUrl" value={projectUrl} onChange={e => setProjectUrl(e.target.value)} />
          </div>
         
          <div>
            <label htmlFor="githubUrl">{t('admin.portfolio.githubUrlLabel')}:</label>
            <input type="text" id="githubUrl" value={githubUrl} onChange={e => setGithubUrl(e.target.value)} />
          </div>
          <div>
            <label htmlFor="category">{t('admin.portfolio.categoryLabel')}:</label>
            <input type="text" id="category" value={category} onChange={e => setCategory(e.target.value)} />
          </div>
        </fieldset>

        <fieldset> 
          <legend>{t('admin.portfolio.translatableDataLegend')} {editingLanguage.toUpperCase()}</legend>
          <div>
            <label htmlFor="currentTitle">{t('admin.portfolio.titleLabel')}:</label>
            <input type="text" id="currentTitle" value={currentTitle} onChange={e => setCurrentTitle(e.target.value)} />
          </div>
          <div>
            <label htmlFor="currentDescription">{t('admin.portfolio.descriptionLabel')}:</label>
            <textarea id="currentDescription" value={currentDescription} onChange={e => setCurrentDescription(e.target.value)} rows="5" />
          </div>
         
        </fieldset>
        
      <button type="submit" disabled={isSaving}>
  {isSaving 
    ? t('admin.buttons.saving', 'Сохранение...') 
    : `${t('admin.buttons.save')} ${editingLanguage.toUpperCase()}`
  }
</button>
      </form>
      {saveStatus.message && (
  <p className={`form-save-status ${saveStatus.type === 'error' ? 'error-message' : 'success-message'}`}>
    {saveStatus.message}
  </p> 
)}
    </div>
  );
}

export default AdminPortfolioEditForm;